/* tslint:disable */
/* eslint-disable */
/* @relayHash cc7de7131379689cbc9067f1d9c964a9 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuTypeaheadQueryVariables = {
    searchString?: string | null;
    hasQuery: boolean;
    facetName?: string | null;
    uriRef?: string | null;
    userCountryCode?: string | null;
};
export type SbSharedRefineMenuTypeaheadQueryResponse = {
    readonly viewer: {
        readonly " $fragmentRefs": FragmentRefs<"SbSharedRefineMenuTypeahead_viewer">;
    };
};
export type SbSharedRefineMenuTypeaheadQuery = {
    readonly response: SbSharedRefineMenuTypeaheadQueryResponse;
    readonly variables: SbSharedRefineMenuTypeaheadQueryVariables;
};



const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "searchString",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "hasQuery",
    "type": "Boolean!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "facetName",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "uriRef",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "userCountryCode",
    "type": "String",
    "defaultValue": ""
  }
],
v1 = {
  "kind": "Variable",
  "name": "facetName",
  "variableName": "facetName"
},
v2 = {
  "kind": "Variable",
  "name": "searchString",
  "variableName": "searchString"
},
v3 = {
  "kind": "Variable",
  "name": "uriRef",
  "variableName": "uriRef"
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SbSharedRefineMenuTypeaheadQuery",
    "type": "RootQueryType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "SbSharedRefineMenuTypeahead_viewer",
            "args": [
              (v1/*: any*/),
              {
                "kind": "Variable",
                "name": "hasQuery",
                "variableName": "hasQuery"
              },
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "kind": "Variable",
                "name": "userCountryCode",
                "variableName": "userCountryCode"
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SbSharedRefineMenuTypeaheadQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "Condition",
            "passingValue": true,
            "condition": "hasQuery",
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "itemFacetSearch",
                "storageKey": null,
                "args": [
                  {
                    "kind": "Variable",
                    "name": "countryCode",
                    "variableName": "userCountryCode"
                  },
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "concreteType": "ItemFacetsQueryConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ItemFacetsQueryEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "FilterValueType",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "urlLabel",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "linkReference",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "displayName",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "count",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "SbSharedRefineMenuTypeaheadQuery",
    "id": "app-buyer-finding/270.0.0-2020-06-25T07:52:06.346Z/SbSharedRefineMenuTypeaheadQuery",
    "text": null,
    "metadata": {}
  }
};
})();
(node as any).hash = '2810cc5020382bd4a02c8854216cadc4';
export default node;
